/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Pipe, PipeTransform} from '@angular/core';
import {NgLocalization, getPluralCategory} from '../localization';
import {invalidPipeArgumentError} from './invalid_pipe_argument_error';

const /** @type {?} */ _INTERPOLATION_REGEXP: RegExp = /#/g;
/**
 * \@ngModule CommonModule
 * \@whatItDoes Maps a value to a string that pluralizes the value according to locale rules.
 * \@howToUse `expression | i18nPlural:mapping`
 * \@description 
 * 
 *  Where:
 *  - `expression` is a number.
 *  - `mapping` is an object that mimics the ICU format, see
 *    http://userguide.icu-project.org/formatparse/messages
 * 
 *  ## Example
 * 
 * {\@example common/pipes/ts/i18n_pipe.ts region='I18nPluralPipeComponent'}
 * 
 * \@experimental
 */
export class I18nPluralPipe implements PipeTransform {
/**
 * @param {?} _localization
 */
constructor(private _localization: NgLocalization) {}
/**
 * @param {?} value
 * @param {?} pluralMap
 * @return {?}
 */
transform(value: number, pluralMap: {[count: string]: string}): string {
    if (value == null) return '';

    if (typeof pluralMap !== 'object' || pluralMap === null) {
      throw invalidPipeArgumentError(I18nPluralPipe, pluralMap);
    }

    const /** @type {?} */ key = getPluralCategory(value, Object.keys(pluralMap), this._localization);

    return pluralMap[key].replace(_INTERPOLATION_REGEXP, value.toString());
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'i18nPlural', pure: true}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgLocalization, },
];
}

function I18nPluralPipe_tsickle_Closure_declarations() {
/** @type {?} */
I18nPluralPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
I18nPluralPipe.ctorParameters;
/** @type {?} */
I18nPluralPipe.prototype._localization;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/common/src/pipes/i18n_plural_pipe.ts